import React from "react";
import type { ApolloClient } from "@apollo/client";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";

import SimpleModal from "components/SimpleModal";
import { advanceYellowPathJourneyRequest } from "services/adminService";
import type { AdvanceYellowPathJourneyMutationVariables } from "types/graphql";

interface OwnProps {
  // PropTypes had entityType as a plain string; it flows straight into the
  // service mutation variables, which type it as the EntityType enum.
  entityType: AdvanceYellowPathJourneyMutationVariables["entityType"];
  entityId: AdvanceYellowPathJourneyMutationVariables["entityId"];
  companyId?: AdvanceYellowPathJourneyMutationVariables["companyId"];
  onClose: (clickingOutsideModal?: boolean) => void;
}

type Props = WithApolloClient<OwnProps>;

const AdvanceAlloyConfirmationModal = ({
  entityType,
  entityId,
  companyId,
  onClose,
  client,
}: Props) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  // service resolves to `string | null` (the mutation payload)
  const [message, setMessage] = React.useState<string | null>();
  const [error, setError] = React.useState<string>();

  const advanceAlloyJourney = async () => {
    setIsSubmitting(true);
    try {
      const response = await advanceYellowPathJourneyRequest(
        client as ApolloClient<object>,
        {
          entityType,
          entityId,
          companyId,
        }
      );
      setMessage(response);
    } catch (err) {
      setError(
        (err as { message?: string })?.message ||
          "An error occurred while advancing the Alloy journey."
      );
    }
    setIsSubmitting(false);
  };

  return (
    <SimpleModal
      show={true}
      onClose={onClose}
      onSubmit={advanceAlloyJourney}
      title="Advance Alloy Journey"
      buttonText="Advance"
      closeButtonText="Cancel"
      showCloseButton={true}
      isXhrRequest={true}
      isFetching={isSubmitting}
      btnDisabled={false}
      error={error}
    >
      <p>Are you sure you want to advance the Alloy journey?</p>
      <p>Entity Id: {entityId}</p>
      <p>Entity Type: {entityType}</p>
      <br />
      {message && (
        <p>
          <strong>Response:</strong> {message}
        </p>
      )}
    </SimpleModal>
  );
};

export default withApollo<Props>(AdvanceAlloyConfirmationModal);
